export default __webpack_public_path__ + "static/media/tablet-icon.f3a93597.svg";